import { split } from 'lodash';

const getFormatTimeToHHMM = (timeString) => {
  const parts = split(timeString, ':');

  return parts?.length > 1 ? `${parts[0]}:${parts[1]}` : '';
};

export default getFormatTimeToHHMM;
